import { DateRange } from 'react-day-picker';

import { format } from 'date-fns';

/**
 * Format a date string in ISO format (YYYY-MM-DD)
 * @param dateString - The date string to be formatted, e.g., "2024-11-09T11:11:20.184Z".
 * @returns The formatted date string in ISO format, e.g., "2024-11-09".
 *
 * @example
 * formatISODate('2024-11-09T11:11:20.184Z');
 * // Returns: "2024-11-09"
 */
export const formatISODate = (dateString: string): string => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDate = (date: Date | string) => format(new Date(date), 'dd MMM, yyyy');
export const formatTime = (date: Date | string) => format(new Date(date), 'hh:mm a');

export const getDateLabel = (dateRange: DateRange) => {
  if (!dateRange.from || !dateRange.to) return 'Select Date';

  return `${format(dateRange.from, 'MM/dd')} - ${format(dateRange.to, 'MM/dd')}`;
};
